import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import ArtificialIntelligenceAssociationIcon from '../../../chicklets/associations/ArtificialIntelligenceAssociationIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MeetingEventChickletPrimaryDisplayLabel = ({
  properties,
  toObjectId,
  toObjectTypeId,
  primaryDisplayProperty,
  isAiAssociation
}) => {
  if (!primaryDisplayProperty || !primaryDisplayProperty.definition) {
    return null;
  }
  const {
    definition,
    value
  } = primaryDisplayProperty;
  const loggedMeetingPlaceholder = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "cardAssociatedObjects.chicklet.AssociationChicklet.loggedMeetingLabel"
  });
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": "crmobject-chicklet-title",
    "data-test-id": "crmobject-chicklet-title",
    children: /*#__PURE__*/_jsxs("strong", {
      "data-selenium-test": "crmobject-chicklet-title-read-only",
      "data-test-id": "crmobject-chicklet-title-read-only",
      "data-unit-test": "crmobject-chicklet-title-read-only",
      children: [/*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: toObjectTypeId,
        objectId: toObjectId.toString(),
        value: value,
        getDraftValue: () => undefined,
        getSavedValue: propertyName => getPropertyValueFromProperties(properties, propertyName),
        "data-selenium-test": `property-input-${definition.name}`,
        "data-test-id": `property-input-${definition.name}`,
        placeholder: loggedMeetingPlaceholder
        // @ts-expect-error Known property issue as they have not updated the type definitions
        // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
        ,
        property: definition
      }), isAiAssociation && /*#__PURE__*/_jsx(ArtificialIntelligenceAssociationIcon, {})]
    })
  });
};
export default MeetingEventChickletPrimaryDisplayLabel;